import { helpers } from 'vuelidate/lib/validators';

export default helpers.regex('alpha', /^(?!-)[a-zA-Zа-яА-ЯёЁ -]*$/);
